import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule, HeaderComponent, FooterComponent, SectionComponent, ConsumerinfoComponent } from './shared';
import { MaterialModule } from './material.module';
import { LoginModule } from './login/login.module';
//import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { IConfig } from 'ngx-mask';
import { AppInitializationService } from './shared/services/app-initialization.service';
//import { FacilityProfileComponent } from './facility-profile/facility-profile.component';

export function initializeApp(appInitService: AppInitializationService) {
  return () => appInitService.init();
}


@NgModule({
    declarations: [
        AppComponent,
        HeaderComponent,
        FooterComponent,
        SectionComponent,
        ConsumerinfoComponent,
        AccessDeniedComponent,
        //FacilityProfileComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        SharedModule,
        MaterialModule,
        LoginModule,
        //MDBBootstrapModule.forRoot()
    ],
    providers: [{
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppInitializationService],
      multi: true
    }],
    bootstrap: [AppComponent]
})
export class AppModule { }
